import { METHOD, request } from '@/utils/request'

export default function download(url, params, fileName) {
   request({
        method:METHOD.GET,
        url:url,
        responseType:'arraybuffer',
        params
    }).then(res => {
        fileName = decodeURIComponent(res.headers['content-disposition'].split('filename=')[1]);
        exportFile(res, fileName)
    })
    // request( url, METHOD.GET, params ,{
    //     responseType: 'arraybuffer'
    // }).then(res => {
    //     exportFile(res, fileName)
    // })
}


function exportFile (res, fileName) {
    try{
        const a = document.createElement('a')
        document.body.appendChild(a)
        let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
        // 使用获取到的blob对象创建的url
        const url = window.URL.createObjectURL(blob)
        a.href = url
        // 指定下载的文件名
        a.download = fileName
        a.click()
        document.body.removeChild(a)
        // 移除blob对象的url
        window.URL.revokeObjectURL(url)
    }catch(e){
        console.log(e)
    }
    
}